<template>
	<div id="associated-users-information" class="tab-pane fade">
		<div v-if="detached" class="alert alert-success alert-dismissible fade show shadow-sm" role="alert">
			User has been detached from company.
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">×</span>
			</button>
		</div>

		<loader-component v-if="loading" :loader-message="'Fetching company users...'"></loader-component>

		<table v-show="!loading" id="associated-users-information" class="table table-striped bd shadow-sm" aria-describedby="associated-users-information">
			<thead>
				<tr>
					<th rowspan="1" colspan="1" scope="col">Name</th>
					<th rowspan="1" colspan="1" scope="col">Email</th>
					<th rowspan="1" colspan="1" scope="col">Phone</th>
					<th rowspan="1" colspan="1" scope="col">Designation</th>
					<th rowspan="1" colspan="1" scope="col"></th>
				</tr>
			</thead>
			<tbody v-if="!isEmpty(companyUsers)" class="px-2">
				<tr v-for="user in companyUsers" :key="user.id">
					<td class="text-capitalize" scope="row">{{ user.fullname }}</td>
					<td>{{ user.email }}</td>
					<td>{{ user.phone }}</td>
					<td class="text-capitalize">{{ user.designation }}</td>
					<td>
						<a href="#" @click.prevent="showUserDetails(user)"><em data-feather="eye" class="text-info wd-15 mg-r-5"></em></a>
						<a href="#" disabled @click.prevent="showEditUserModal(user)"><em data-feather="edit" class="text-primary wd-15 mg-r-5"></em></a>
						<a href="#" @click.prevent="showDetachUserModal(user)"><em data-feather="user-x" class="text-warning wd-15 mg-r-5"></em></a>
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr>
					<td colspan="5" class="text-center">Company has no attached users</td>
				</tr>
			</tbody>
		</table>

		<detach-user-modal :user="userToDetach" @detach-user="detachUser(userToDetach)" />
		<view-attached-institution-user-modal-component :modal-id="'company-user-modal'" :title="viewModalTitle" :user="modalUser" />
		<edit-company-user-modal :user="editUser" @refresh="fetchUsers"/>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	data() {
		return {
			companyUsers: [],
			detached: false,
			loading: true,
			viewModalTitle: 'Company User',
			modalUser: null,
			editUser: null,
			userToDetach: null,
		};
	},
	created() {
		this.fetchUsers();
	},
	methods: {
		showUserDetails(user) {
			this.modalUser = user;
			this.viewModalTitle = user.fullname

			$('#company-user-modal').modal('show');
		},
		showEditUserModal(user) {
			this.editUser = user;

			$('#edit-company-user-modal').modal('show');
		},
		showDetachUserModal(user) {
			this.userToDetach = user;

			$('#detach-user-modal').modal('show');
		},
		fetchUsers() {
			axios
				.get(`/api/companies/${this.company}/users`)
				.then(({ data: { data } }) => {
					this.companyUsers = data.users;
				})
				.finally(() => {
					this.loading = false;
					feather.replace();
				});
		},
		detachUser({ id: user}) {
			axios
				.post(`/api/companies/${this.company}/detach-user`, {
					user,
				})
				.then(() => {
					$('#detach-user-modal').modal('hide');

					this.detached = true;
					this.fetchUsers();
				});
		},
	},
	props: {
		company: {
			type: String,
			required: true,
		},
	},
};
</script>
